import { gql } from '@apollo/client';

export const REFUND_APP_ORDER = gql`
  mutation refundAppOrder($orderId: ID!, $refundReceiptNumber: Int, $deviceId: String) {
    refundOrder(
      orderId: $orderId
      refundReceiptNumber: $refundReceiptNumber
      deviceId: $deviceId
    ) {
      success
      error
      message
    }
  }
`;

export const REFUND_POS_ORDER = gql`
  mutation refundPosOrder($orderId: ID!, $refundReceiptNumber: Int, $deviceId: String) {
    refundPosOrder(
      orderId: $orderId
      refundReceiptNumber: $refundReceiptNumber
      deviceId: $deviceId
    ) {
      success
      error
      message
    }
  }
`;

export const REFUND_ITEM = gql`
  mutation refundOrderItem(
    $orderId: ID!
    $itemId: ID!
    $refundReceiptNumber: Int
    $deviceId: String
  ) {
    refundOrderItem(
      orderId: $orderId
      itemId: $itemId
      refundReceiptNumber: $refundReceiptNumber
      deviceId: $deviceId
    ) {
      success
      error
      message
    }
  }
`;

export const REFUND_TIP = gql`
  mutation refundTip($orderId: ID!, $tipAmount: Int!, $transactions: [TransactionInput!]!) {
    refundTip(orderId: $orderId, tipAmount: $tipAmount, transactions: $transactions) {
      error
      success
      message
    }
  }
`;

export const REFUND_MULTIPAY_TIP = gql`
  mutation refundMultiPayTips(
    $orderId: ID!
    $subPayments: [RefundMultiPayTipsInput!]!
    $transactions: [TransactionInput!]!
  ) {
    refundMultiPayTips(orderId: $orderId, subPayments: $subPayments, transactions: $transactions) {
      error
      success
      message
    }
  }
`;
